import React from 'react'
import { Box } from 'grommet'
// import { StaticQuery, graphql } from "gatsby"
// import Img from "gatsby-image"
import styled, { keyframes } from 'styled-components'

const rotation = keyframes`
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
  }
`
// const SpinningImg = styled(Image)`

// `

const PositionBox = styled(Box)`
  position: ${props => props.position};
`

const Wheel = styled(Box)`
  width: ${props => props.size};
  height: ${props => props.size};
  border-radius: 50%;
  position: relative;
  background-image: ${props => props.colorsString};
  animation: ${rotation} 0.25s infinite linear;
  &:after {
    content: '';
    width: ${props => props.spaceSize};
    height: ${props => props.spaceSize};
    position: absolute;
    background-color: white;
    border-radius: 50%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`
const toolColors = ['#2B580C', '#F7B71D', '#AFA939', '#FDEF96']
const SpinningWheelLogo = ({
  size = '10rem',
  spaceSize = '3rem',
  position = 'relative',
  ...props
}) => {
  //   const pieAngle = 90
  //   let tempColorString = "conic-gradient("
  //   for (let i = 0; i < toolColors.length; i++) {
  //     let j = i;
  //     if (i===1) {
  //       j = 2;
  //     } else if (i===2) {
  //       j = 1;
  //     }
  //     tempColorString = tempColorString + `${toolColors[j]} 0 ${pieAngle*(i+1)}deg, `
  //   }
  //   const colorsString = tempColorString.slice(0, -2) + ")"
  const colorsString = `conic-gradient(
        ${toolColors[0]} 0 90deg,
        ${toolColors[2]} 0 180deg,
        ${toolColors[1]} 0 270deg,
        ${toolColors[3]} 0 360deg
      )`
  return (
    <PositionBox
      {...props}
      width={size}
      height={size}
      align="center"
      justify="center"
      alignSelf="center"
      position={position}
    >
      <Wheel colorsString={colorsString} size={size} spaceSize={spaceSize} />
    </PositionBox>
  )
}

export default SpinningWheelLogo
